<div class="container">
    <h2>Vote for your favorite PowerUp! Grand Final Startup:</h2>
    <div class="row">
        <div class="col-12 startups-wrapper">
            <div class="startup" *ngFor="let startup of startups | async">
                <div class="startup-inner">
                    <h5>{{startup.name}} {{startup.lastname}}</h5>
                    <h4>{{startup.startup}}</h4>
                    <h6>{{startup.country}}</h6>
                    <p>{{startup.description}}</p>
                </div>
                <ng-container *ngIf="auth.user$ | async as user">
                    <button class="bl-btn bl-btn-outline"
                        *ngIf="!user.voted"
                        (click)="vote(startup.id)"
                        >Vote</button>
                        <ng-container *ngIf="user.voted">
                            <div class="startup-score">
                                <h4>Score: {{startup.votes}}</h4>
                            </div>
                        </ng-container>
                        
                </ng-container>
            </div>
        </div>
    </div>
</div>